"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const StyledCustomInput = styled_components_1.default.div `
  display: flex;
  align-items: center;
  border: 1px solid;
  border-color: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.neutral.light};
  width: ${({ isSelectsRange }) => (isSelectsRange ? "220px" : "180px")};
  height: 32px;
  background-color: ${({ disabled, theme }) => disabled ? theme.neutral.lighter : theme.white};
  border-radius: 4px;
  position: relative;
  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    border-color: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.primary.main};
    & > span {
      border-left: 1px solid;
      border-color: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.primary.main};
    }
  }
  &:focus-within {
    border-color: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.primary.main};
    .calendar-icon {
      fill: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.primary.main};
    }
  }

  &:hover .calendar-icon {
    fill: ${({ disabled, theme }) => disabled ? theme.neutral.main : theme.primary.main};
  }

  & > span {
    border-left: 1px solid ${({ theme }) => theme.neutral.light};
    height: 31px;
    width: 32px;
    display: grid;
    place-items: center;
  }
  .calendar-icon {
    fill: ${({ theme }) => theme.neutral.main};
    margin-left: 2px;
  }

  & > input {
    background: transparent;
    border: none;
    color: ${({ disabled, theme }) => disabled ? theme.text.secondary : theme.text.primary};
    display: ${({ isFocused, isSelectsRange }) => isFocused && !isSelectsRange ? "none" : "block"};
    font-size: ${({ isSelectsRange }) => (isSelectsRange ? "13px" : "14px")};
    font-family: Gotham A, Gotham B;
    text-transform: uppercase;
    height: 30px;
    padding-left: ${({ isSelectsRange }) => (isSelectsRange ? "10px" : "14px")};
    outline: none;
    width: calc(100% - 32px);
    letter-spacing: ${({ isSelectsRange }) => isSelectsRange ? "normal" : "1px"};
    ::placeholder {
      color: ${({ theme }) => theme.text.secondary};
      font-size: 13px;
      font-family: Gotham A, Gotham B;
    }
    ::-webkit-calendar-picker-indicator {
      display: none;
    }

    &:focus-visible,
    &:focus {
      border: none;
      outline: none;
    }
  }
`;
exports.default = StyledCustomInput;
